module.exports = __webpack_public_path__ + "media/images/shared/icon-scroll-down-e2da52833692bb31b240e0ca7aeb43c7.png";